import './App.css';
import React, {CSSProperties, useCallback, useEffect, useRef, useState} from 'react'
import {useDropzone} from 'react-dropzone'
import forge from 'node-forge';
import { useCollapse } from "react-collapsed";
import PacmanLoader from "react-spinners/PacmanLoader";
import SignatureCanvas from 'react-signature-canvas';
import DownloadCsvIcon from "./Csv"

const loaderOverride: CSSProperties = {
  display: "flex",
  margin: "auto",
  borderColor: "red",
  opacity: 1.0,
};


/**
 * Decrypts an encrypted payload using RSA private key (for AES key) and AES-GCM (for data).
 * @param encryptedPayload - The encrypted object.
 * @param privateKeyPem - The RSA private key in PEM format.
 * @returns The decrypted plaintext.
 */
export function hybridDecrypt(encryptedPayload: any, privateKeyPem: string): string | null {
  //console.error(encryptedPayload)
    try {
        // Convert the private key from PEM format to Forge format
        const privateKey = forge.pki.privateKeyFromPem(privateKeyPem);

        // Step 1: Decrypt the AES key using RSA private key
        const decryptedAesKey = privateKey.decrypt(
            forge.util.decode64(encryptedPayload.encryptedAesKey),
            "RSA-OAEP",
            {
                md: forge.md.sha256.create(),
            }
        );

        // Convert AES key to a Forge buffer
        const aesKeyBuffer = forge.util.createBuffer(decryptedAesKey, "raw");

        // Step 2: Decrypt the data using AES-GCM
        const decipher = forge.cipher.createDecipher("AES-GCM", aesKeyBuffer.getBytes());

        // Convert IV and AuthTag from Base64 to ByteBuffer
        const iv = forge.util.createBuffer(forge.util.decode64(encryptedPayload.iv));
        const authTag = forge.util.createBuffer(forge.util.decode64(encryptedPayload.authTag));

        // Set IV and authentication tag
        decipher.start({ iv, tag: authTag });

        // Update the encrypted data
        decipher.update(forge.util.createBuffer(forge.util.decode64(encryptedPayload.encryptedData)));

        // Finalize decryption
        const success = decipher.finish();

        if (!success) {
            console.error("Decryption failed: Authentication failed.");
            return null;
        }

        // Convert decrypted data to string
        return decipher.output.toString();
    } catch (error) {
        console.error("Error during decryption:", error);
        return null;
    }
}


  
  /*
  const decrypt=(data:string[], privKey:string):string[]=>{
    //const privateKey = forge.pki.privateKeyFromPem(privKey);
    const decryptedStrings = data.map((encrypted) => {
      const encryptedJson = JSON.parse(encrypted)
      console.error("Decrypting: ", encryptedJson);
      return hybridDecrypt(encryptedJson, privKey)!;
    });
    return decryptedStrings;
  }
  */
  
  const decryptAsyncWithProgress = async (data: string[], privKey: string, setDecryptedDatasetAmount:any): Promise<object[]> => {
    const results: object[] = [];
    for (let i = 0; i < data.length; i++) {
      const encryptedJson = JSON.parse(data[i]);
      const decryptedString = hybridDecrypt(encryptedJson, privKey)!;
      const decryptedJson=JSON.parse(decryptedString)
      decryptedJson.checkIn=encryptedJson.checkIn;
      results.push(decryptedJson);
      setDecryptedDatasetAmount(i + 1); // Updates progress
      await new Promise(resolve => setTimeout(resolve, 1)); // Let React update
    }
    return results;
  };

async function deleteEntry(idx:number, deleteSet:any ){
  if (window.confirm("Sicher dass du diesen Eintrag löschen möchtest?") == true) {
      //data.splice(idx,1);
      //create a new array so react do rerender.
      const newData = deleteSet.data.filter((_:any, i:number) => i !== idx);
      deleteSet.setData(newData);
      const response = await fetch("/api/delete", {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Sending JSON data
        },
        body: JSON.stringify({
          password: deleteSet.password,     // Send password to server
          idx: idx,     // Send password to server
        }),
      });
      if (response.ok) {
          //console.log("Password sent successfully.");
        alert("Erfolgreich gelöscht!")
      } else {
        alert("Fehler beim Löschen!")
      }

  }
}

async function toggleCheckin(idx:number, deleteSet:any ){
      const data=deleteSet.data;
      //data[idx].checkIn=!data[idx].checkIn;
      //create a new array so react do rerender.
      const newData = data.map((item:any, i:number) =>
        i === idx ? { ...item, checkIn: !item.checkIn } : item
      );
      deleteSet.setData(newData);
      await new Promise(resolve => setTimeout(resolve, 1)); // Let React update state
      const response = await fetch("/api/toggleCheckIn", {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Sending JSON data
        },
        body: JSON.stringify({
          password: deleteSet.password,     // Send password to server
          idx: idx,     // Send password to server
        }),
      });
      if (response.ok) {
          //console.log("Password sent successfully.");
      } else {
        alert("Fehler beim ändern des Checkin Statuses!")
      }

}
function Entry({data, idx, deleteSet}:any){
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();
  const sigRef:any=useRef(null);
  const sigRefSepa:any=useRef(null);

  useEffect(() => {
    if (sigRef!=null) {
          sigRef.current.getSignaturePad().fromData(data.sigData);
          sigRef.current.off();
        }
    if (sigRefSepa!=null) {
          sigRefSepa.current.getSignaturePad().fromData(data.sigDataSepa);
          sigRefSepa.current.off();
        }
  }, [data]); // Runs only when `data` changes

  return(
    <div style={{textAlign: "left", padding: "5%",borderBottom: "1px solid"}}>
      <div style={{margin: "auto",position: "relative"}}>
        <span>
          {data.prename}&nbsp;&nbsp;&nbsp;
          {data.name}
        </span>&nbsp;&nbsp;&nbsp;
          <div style={{float: "right", display: "inline-block"}}>
            <span>
              An board:
            </span>
            <input type="checkbox"
              checked={data.checkIn}
              onChange={() => toggleCheckin(idx, deleteSet)}
              style={{marginTop: "10px", borderRadius: "3px" ,maxWidth:"100px"}}
            />
          </div>

        <div>
          <div>

            IBAN&BIC:
          </div>
          <div>
            {data.iban}&nbsp;&nbsp;&nbsp;
            {data.bic}
          </div>
        </div>


        <span style={{cursor: "pointer", textDecoration: "underline"}} onClick={getToggleProps().onClick}>
          {isExpanded ? "weniger" : "mehr..."}
        </span>
      </div>
      <section {...getCollapseProps()}>
        <p>Geburtstag:&nbsp;{data.birth}</p>
        <p>Email:&nbsp;{data.mail}</p>
        <p>Straße:&nbsp;{data.street}&nbsp;&nbsp;Nr:&nbsp;{data.number}</p>
        <p>PLZ:&nbsp;{data.plz}&nbsp;&nbsp;Stadt:&nbsp;{data.city}</p>
        <p>IBAN:&nbsp;{data.iban}</p>
        <p>BIC:&nbsp;{data.bic}</p>
        <p>Solibeitrag:&nbsp;{data.soli==="true"?"ja":"nein"}</p>
        <p>Unterschrift:</p>
        <div style={{width: data.sigWidth+"px"}}>
          <SignatureCanvas  penColor="#014479" canvasProps={{ width: data.sigWidth, height: "120px", className: "sigCanvas" }} ref={sigRef} />
        </div>
        <p>Sepa Unterschrift:</p>
        <div style={{width: data.sigWidthSepa+"px"}}>
          <SignatureCanvas  penColor="#014479" canvasProps={{ width: data.sigWidthSepa, height: "120px", className: "sigCanvasSepa" }} ref={sigRefSepa} />
        </div>

        <div>
          <br></br>
          <button onClick={()=>deleteEntry(idx, deleteSet)}>Eintrag löschen</button>
        </div>

      </section>
    </div>
  );
}

function Admin() {
    //const {clientWidth, clientHeight} =  document.documentElement;
    //const [mobile, setMobile] = React.useState(clientWidth < clientHeight);
    const [privKey, setPrivKey]=useState(localStorage.getItem("privKey"));
    const [password, setPassword]=useState("");
    const [data, setData]=useState([] as object[]);
    const [decrypting, setDecrypting]=useState(false);
    const [submitted, setSubmitted]=useState(false);
    const [decryptedDatasets, setDecryptedDatasetAmount]=useState(0);
    const [datasetsTotal, setDatasetsTotal]=useState(0);
//React.useEffect(() => {
//    console.error("Updated datasetsTotal:", datasetsTotal);
//}, [datasetsTotal]);

    //window.addEventListener("resize", ()=>{
    //    setMobile(document.documentElement.clientWidth < document.documentElement.clientHeight);
    //});
    


    const getData = async (password:string) => {
        const response = await fetch("/api/getData", {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Sending JSON data
          },
          body: JSON.stringify({
            password: password,     // Send password to server
          }),
        });
        if (response.ok) {
            setDecrypting(true);
            setSubmitted(true);
            const responseData:any = await response.json();
            const data:string[]=responseData.data;
            //console.error("Encrypted DATA", data);
            //console.error("DATALEN",data.length);
            setDatasetsTotal(data.length);
            await new Promise(resolve => setTimeout(resolve, 1)); // Let React update state
            //const decryptedData=decrypt(data, privKey!)
            const decryptedData=await decryptAsyncWithProgress(data, privKey!, setDecryptedDatasetAmount)
            //console.error("Decrypted DATA",decryptedData);
            //const decryptedJson=decryptedData.map(entry=>JSON.parse(entry));
            const decryptedJson=decryptedData;
            setDecrypting(false);
            setData(decryptedJson);
            //console.log("Password sent successfully.");
        } else {
          //console.log("Error sending password.");
          setPassword("");
          //setDecrypting(false);
          //setSubmitted(false);
          alert("Falsches PASSWORT!")
        }
    };

    

  return (
    <div className="App">
      <header className="App-header">
        <img className="logo" src="/images/logo.png" alt="logo" />
      </header>

      <h1>Admin Pannel</h1>
      <br></br>
      {privKey==null&&
        <MyDropzone setPrivKey={setPrivKey}></MyDropzone>
      }

      <br></br>

      {
      !submitted&&
      <div style={{fontSize:"20px", width:"45%", margin: "auto", textAlign: "left"}}>
        <label>Passwort:</label>
        <input type="password" value={password} placeholder='' id="password" name="password" onChange={(event)=>{setPassword(event.target.value)}}/><br/><br/>
      </div>
      }


      {privKey!=null&&
      password.length>0&&
      !submitted&&
        <button onClick={()=>{getData(password)}}>Hol die Daten!</button>
      }

      <PacmanLoader
        color={"#FFEC01"}
        loading={decrypting}
        size={150}
        cssOverride={loaderOverride}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
      {decrypting&&//({decryptedDatasets}/{datasetsTotal})
        <>
          <h1>Entschlüssele Daten...</h1>
          <h2>{decryptedDatasets}/{datasetsTotal}</h2>
        </>
      }
      {data.length>0&&

        <>
          <div>
            ALLE:
          </div>
          <div>
            <DownloadCsvIcon data={data} filename={'Chor_Mitglieder.csv'} filter={false}></DownloadCsvIcon>
          </div>
          <div>
            Nur Leute die nicht an Board sind:
          </div>
          <div>
            <DownloadCsvIcon data={data} filename={'Chor_Mitglieder.csv'} filter={true}></DownloadCsvIcon>
          </div>
          <div style={{width: "50vw", margin: "auto", border: "2px solid", borderRadius:"15px"}}>
            {data.map((d, idx)=><Entry data={d} idx={idx} deleteSet={{data: data, setData: setData, password: password}}/>)}
          </div>
        </>
      }

      <footer className='footer'>
        <Grid>
          {/*<img className="logo" src="/images/herri.png" alt="sponsor" />*/}
          <img className="logo" src="/images/lw.png" alt="sponsor" />
          <img className="logo" src="/images/hanne.png" alt="sponsor" />
        </Grid>
      </footer>

    </div>
  );
}

type GridProps={
  children:any
}
function Grid({children}:GridProps){
  return <div className='GridParent'>
    {children}
  </div>

}
function MyDropzone({setPrivKey}:any) {
  const onDrop = useCallback((files:any) => {
      const file = files[0]; // Take the first file if multiple are dropped
      const reader = new FileReader();
      reader.onload = (event:ProgressEvent<FileReader>) => {
        const fileContent = event?.target?.result;
        localStorage.setItem("privKey", fileContent as string); // ✅ Save to localStorage (overrides previous)
        if(fileContent?.toString().startsWith("-----BEGIN PRIVATE KEY-----",0)){
          setPrivKey(fileContent);
        }
        else{
          alert("Das hier hat nichts mit einer PrivKey Datei zu tun! :(");
          return;
        }
      };
    reader.readAsText(file); // ✅ Read file as text (for .txt, .json, etc.)
  }, [])
  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})

  return (
    <div style={{
      border: "5px dashed #FF89D5",
      borderRadius: "25px",
      width: "40%",
      height: "30%",
      textAlign: "center",
      margin: "auto",
      padding: "10px",
      }}{...getRootProps()}>
      <input {...getInputProps()} />
      {
        isDragActive ?
          <p>Fast geschafft, nur noch hier loslassen! :)</p> :
          <p>Um die Daten zu entschlüsseln, die PEM-Datei hier hinein Drag 'n' droppen </p>
      }
    </div>
  )
}

export default Admin;
